import { render, staticRenderFns } from "./LicenseList.vue?vue&type=template&id=e35ecb48&scoped=true&"
import script from "./LicenseList.vue?vue&type=script&lang=js&"
export * from "./LicenseList.vue?vue&type=script&lang=js&"
import style0 from "./LicenseList.vue?vue&type=style&index=0&id=e35ecb48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35ecb48",
  null
  
)

export default component.exports